var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMineOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("span", {
    role: "img",
    className: "anticon anticon-mine",
    "aria-label": "mine"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 7.00012V20.0001L6 20V13V10.5V7.00012H4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20.0001V7.00012L14 7V20L16 20.0001Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.288 6.00012C0.479333 6.28346 0.716667 6.51679 1 6.70012C1.33333 6.80008 2.2 7.00012 3 7.00012H4H6L9 7.00008L11 7.00005L14 7L16 7.00012H17C17.8 7.00022 18.6667 6.80016 19 6.70012C19.2833 6.51679 19.5207 6.28346 19.712 6.00012C19.904 5.71679 20 5.38346 20 5.00012V2.00012C20 1.45012 19.8043 0.979122 19.413 0.587122C19.021 0.195789 18.55 0.00012207 18 0.00012207H2C1.45 0.00012207 0.979333 0.195789 0.588 0.587122C0.196 0.979122 0 1.45012 0 2.00012V5.00012C0 5.38346 0.0960001 5.71679 0.288 6.00012ZM18 2.00012V5.00012H2V2.00012H18Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 7.00012C2.2 7.00012 1.33333 6.80008 1 6.70012V20H3V7.00012Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 6.70012C18.6667 6.80016 17.8 7.00022 17 7.00012V20.0001H19V6.70012Z",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMineOutlined);
export default __webpack_public_path__ + "static/media/mine-outlined.a41f807b5fdd6e93840eb89fc14aa9f1.svg";
export { ForwardRef as ReactComponent };